(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('shipping-protection')) {
    customElements.define('shipping-protection', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.input?.addEventListener('change', () => this.update(this.input.checked));

        if (this.dataset.removeOrphan === 'true') {
          this.update(false);
        }
      }

      async update(enabled) {
        if (this.updating) return;

        this.updating = true;
        if (this.input) this.input.disabled = true;
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections }
        }));

        const isAdding = enabled && !this.dataset.lineKey;
        const url = `${Shopify.routes.root}cart/${isAdding ? 'add' : 'change'}.js`;
        const payload = isAdding
          ? { items: [{ id: Number(this.dataset.variantId), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname }
          : { id: this.dataset.lineKey, quantity: enabled ? 1 : 0, sections: sections.join(','), sections_url: window.location.pathname };

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
          });
          const responseJson = await response.json();

          if (!response.ok) throw new Error(responseJson.description || 'Unable to update shipping protection.');

          const cart = isAdding ? await (await fetch(`${Shopify.routes.root}cart.js`)).json() : responseJson;
          if (isAdding) cart.sections = responseJson.sections;

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'shipping-protection:change', cart }
          }));
        } catch (error) {
          if (this.input) this.input.checked = !enabled;
          const errorElement = this.querySelector('.shipping-protection__error');
          if (errorElement) {
            errorElement.textContent = error.message;
            errorElement.hidden = false;
          }
        } finally {
          this.updating = false;
          if (this.input) this.input.disabled = false;
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
